import { createStyles } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      borderRadius: 8,
      border: `1px solid ${theme.colors.neutral[1]}`,
      boxShadow: theme.shadows.sm,
      backgroundColor: '#fff',
    },
    info: {
      display: 'flex',
      flexDirection: 'column',
      padding: 16,
      gap: 12,

      [theme.fn.smallerThan('sm')]: {},
      [theme.fn.largerThan('sm')]: {
        width: 320,
        flexShrink: 0,
        justifyContent: 'space-between',
        borderTopLeftRadius: 'inherit',
        borderBottomLeftRadius: 'inherit',
      },
    },
    topInfo: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      alignItems: 'flex-start',
    },
    countdown: {
      width: '100%',
      [theme.fn.largerThan('sm')]: {
        order: 2,
      },
    },
    title: {
      [theme.fn.smallerThan('sm')]: { textAlign: 'center' },
      [theme.fn.largerThan('sm')]: {
        order: 1,
      },
    },
    thumbFrame: { '&, *, img': { borderRadius: 'inherit' } },
    thumbImg: { borderRadius: 'inherit', display: 'block' },
    action: {
      [theme.fn.largerThan('sm')]: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      },
    },
  }
})
